import "./styles.css";
import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  LayersControl,
  LayerGroup,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { HeatmapLayer } from "react-leaflet-heatmap-layer-v3";
import icon from "./constants";
import PlaceIcon from "@mui/icons-material/Place";
import ModalPopupMap from "./modalPopupMap";
import MarkerClusterGroup from "react-leaflet-cluster";
import { useQueryClient } from "react-query";
import { LAT_LNG } from "../../config/cacheKey";
function FlyLoc({ location, search }) {
  const map = useMap();
  if (search.lat != 0) {
    const lat = search.lat;
    const lng = search.lng;
    map.flyTo([lat, lng], 11);
  }
}
export default function MapComponent(props) {
  const [loc, updLoc] = useState();
  useEffect(() => {
    // const geocoder = L.Control.Geocoder.nominatim();
    if (props.flyToLoc) {
      updLoc(props.flyToLoc);
    }
  }, [props.flyToLoc]);
  const queryClient = useQueryClient();
  queryClient.setQueryData(LAT_LNG, [32.018373, 53.311462]);
  const center = queryClient.getQueryData(LAT_LNG);
  function LocationMarker() {
    const [position, setPosition] = useState(null);
    const [bbox, setBbox] = useState([]);

    const map = useMap();

    // useEffect(() => {
    //   map.locate().on("locationfound", function(e) {
    //     setPosition(e.latlng);
    //     map.flyTo(e.latlng, map.getZoom());
    //     const radius = e.accuracy;
    //     const circle = L.circle(e.latlng, radius);
    //     circle.addTo(map);
    //     setBbox(e.bounds.toBBoxString().split(","));
    //   });
    // }, [map]);
    // return position === null ? null : (
    //   <Marker position={position} icon={icon}>
    //     <Popup>
    //       You are here. <br />
    //       Map bbox: <br />
    //       <b>Southwest lng</b>: {bbox[0]} <br />
    //       <b>Southwest lat</b>: {bbox[1]} <br />
    //       <b>Northeast lng</b>: {bbox[2]} <br />
    //       <b>Northeast lat</b>: {bbox[3]}
    //     </Popup>
    //   </Marker>
    // );
  }
  function madeIcone(color) {
    var svg = `<img src='./images/markerMap2.svg' class="iconStyleMap"/>`;
    return new L.divIcon({
      // iconUrl:
      //   "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
      // shadowUrl:
      //   "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
      html: svg,
      iconSize: [25, 41],
      iconAnchor: [5, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });
  }

  let PlaceIcon = <PlaceIcon />;
  return (
    <MapContainer
      center={[32.018373, 53.311462]}
      zoom={6}
      scrollWheelZoom
      style={{ height: "75vh", marginLeft: "100px", zIndex: "50" }}
    >
      <LayersControl position="topright">
        <LayersControl.BaseLayer checked name="نقشه OpenStreetMap ">
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
        </LayersControl.BaseLayer>
        <LocationMarker />
        <LayersControl.BaseLayer name="نقشه Google ">
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}"
          />
        </LayersControl.BaseLayer>
        <LayersControl.Overlay checked name="نمایش شعبات ">
          <LayerGroup>
            <MarkerClusterGroup maxClusterRadius={10} chunkedLoading>
              {props.data.map((item, index) => (
                <Marker
                  position={[item.lat, item.lng]}
                  icon={madeIcone(item.colorCode)}
                >
                  <Popup>
                    <ModalPopupMap
                      supplierTitle={item.supplierTitle}
                      provinceTitle={item.provinceTitle}
                      cityTitle={item.cityTitle}
                      salesInfos={item.salesInfos}
                    />
                  </Popup>
                </Marker>
              ))}
            </MarkerClusterGroup>
          </LayerGroup>
        </LayersControl.Overlay>
        <LayersControl.Overlay name="نقشه حرارتی ">
          <LayerGroup>
            <HeatmapLayer
              maxZoom={12}
              fitBoundsOnLoad
              fitBoundsOnUpdate
              points={Object.values(props.points)}
              longitudeExtractor={(m) => m[1]}
              latitudeExtractor={(m) => m[0]}
              intensityExtractor={(m) => parseFloat(m[2])}
              radius={35}
              max={props.weight?.maxWeight}
              // minOpacity={1}
              useLocalExtrema={true}
            />
          </LayerGroup>
        </LayersControl.Overlay>
      </LayersControl>
      <FlyLoc location={loc} search={props.flyToLoc} />
    </MapContainer>
  );
}
